var _defs, _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHosting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79.45 53.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-linecap: round;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #2e002f;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-width: 3px;\n      }\n\n      .cls-3 {\n        fill: #ffa0ff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.82,50.25c5.07-5.03,8.49-14.6,2.28-19.83-.13-.11-.25-.23-.37-.34-1.35-.93-2.15-2.61-2.25-4.18-.34-5.37-3.42-8.64-8.53-10.24,0,0,0,0-.01,0-1.78-.34-3.66-.09-5.48.35C56.22,7.51,49.98.94,41.33.08c-5.5-.55-11.02,1.89-14.53,6.92-.99,1.42-1.8,2.99-2.43,4.65-2.39-1.87-5.29-2.73-8.17-2.32-2.95.42-5.35,2.15-6.26,5.57-.41,1.53-.53,3.16-.78,4.74C3.74,22.5,0,28.59,0,35.64c0,8.22,5.09,15.14,12,17.14v.13s.05.02.07.02c.99.13,1.97.28,2.95.43h49.85v-.07c.55-.06,1.1-.17,1.63-.32,1.08-.1,2.16-.32,3.21-.66.89-.23,1.73-.59,2.51-1.07.55-.3,1.08-.63,1.59-1Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.33,
    y: 19.46,
    width: 50.79,
    height: 11.38,
    rx: 5.6,
    ry: 5.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 23.09,
    cy: 25.15,
    r: 2.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.05,
    y: 24.28,
    width: 5.69,
    height: 2.19,
    rx: 1.08,
    ry: 1.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.05,
    y: 24.28,
    width: 5.69,
    height: 2.19,
    rx: 1.08,
    ry: 1.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 23.09,
    y1: 24.28,
    x2: 23.09,
    y2: 26.03
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.33,
    y: 35.79,
    width: 50.79,
    height: 11.38,
    rx: 5.6,
    ry: 5.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 23.09,
    cy: 41.48,
    r: 2.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.05,
    y: 40.6,
    width: 5.69,
    height: 2.19,
    rx: 1.08,
    ry: 1.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.05,
    y: 40.6,
    width: 5.69,
    height: 2.19,
    rx: 1.08,
    ry: 1.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 23.09,
    y1: 40.6,
    x2: 23.09,
    y2: 42.35
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHosting);
export default __webpack_public_path__ + "static/media/hosting.c220fcb7fc38c983face7f1477c054cd.svg";
export { ForwardRef as ReactComponent };